import React from 'react';
import { useFormContext } from 'react-hook-form';
import Markdown from 'markdown-to-jsx';
import classnames from 'classnames';

import InputError from './Error';
import renderers from '../renderers';

const FormCheckbox = ({
  disabled = false,
  name,
  label,
  required = false,
  validation = {},
}) => {
  const { errors, register } = useFormContext();

  const isRequired = required ? 'Field is required' : false;
  const isError = errors[name];

  const inputClass = classnames('flex items-baseline', {
    'cursor-not-allowed opacity-50': disabled,
    'cursor-pointer': !disabled,
  });

  return (
    <div className="mb-4">
      <label className={inputClass}>
        <input
          className="mr-2 leading-tight"
          name={name}
          type="checkbox"
          disabled={disabled}
          ref={register({
            required: isRequired,
            ...validation,
          })}
        />
        <span className="font-medium text-grey-800 text-sm">
          <Markdown
            children={label}
            options={{
              forceBlock: true,
              overrides: {
                a: renderers.Link,
              },
            }}
          />
        </span>
      </label>
      {isError && <InputError>{errors?.[name]?.message}</InputError>}
    </div>
  );
};

export default FormCheckbox;
